import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IPolicyEligibleServicesDto } from '@/dtos';

interface Props {
  policyIds?: (string | number)[];
  searchString?: string;
}

export const useGetServicesByAiQuery = ({ policyIds, searchString }: Props) => {
  const { data, isLoading, isError } = useQuery(
    [API_URL.AI_SEARCH_SERVICES_BY_PLAN, policyIds, searchString],
    () => api.get<IPolicyEligibleServicesDto[]>(API_URL.AI_SEARCH_SERVICES_BY_PLAN,
      {
        params: {
          policy_ids: policyIds?.join(','),
          search_string: searchString,
        }
      }
    ),
    {
      enabled: (!!policyIds && policyIds.length > 0) && (!!searchString && searchString.length >= 3),
      retry: false,
    }
  );

  return {
    data: data?.data ?? [],
    isLoading,
    isError,
  };
};
